import { useCheckout } from '@core/context/checkoutContext';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import astropayLogo from '@assets/logos/astropay-logo.png';
import { APIcon } from '@components/atoms/APIcon';
import { APImage } from '@components/atoms/APImage';

export const CheckoutHeader = () => {
  const { t } = useTranslation();
  const { merchantLogoUrl, onBack } = useCheckout();
  const [logoError, setLogoError] = useState(false);

  // undefined means payment details haven't loaded yet — render nothing to avoid a flash
  const isLoading = !merchantLogoUrl;
  const logoSrc = logoError ? astropayLogo : (merchantLogoUrl ?? astropayLogo);

  return (
    <div className="flex items-center justify-between w-full h-12 pt-2 pb-3 px-1 max-w-2xl mx-auto">
      {onBack ? (
        <button
          onClick={onBack}
          aria-label={t('Checkout.return')}
          className="w-8 h-8 flex items-center justify-center -ml-1 bg-transparent border-0 cursor-pointer"
        >
          <APIcon img="chevronLeftLine" size={22} className="!mr-0" />
        </button>
      ) : (
        <div className="w-8" />
      )}

      {isLoading ? (
        <div className="!w-auto !h-[26px]" style={{ width: 114 }} />
      ) : (
        <APImage
          img={logoSrc}
          width={114}
          height={26}
          alt={t('AstroPayDownload.title')}
          loadingStrategy="eager"
          className="!w-auto !h-[26px] !mr-0 object-contain"
          onError={() => setLogoError(true)}
        />
      )}

      <div className="w-8" />
    </div>
  );
};
